import { UseRuleGroup } from "react-querybuilder";
import React from "react";
import classNames from "classnames";
import CiroDropdown from "../../../../shared/CiroDropdown";

const PowersearchRuleGroupHeaderElements: (
  rg: UseRuleGroup,
) => React.JSX.Element = (rg: UseRuleGroup) => {
  return (
    <div
      className={classNames(
        "flex",
        "w-full",
        "justify-between",
        "items-center",
      )}
    >
      <div
        className={classNames(
          "flex",
          "justify-between",
          "items-center",
          "w-full",
        )}
      >
        <div className={classNames("flex", "items-center", "gap-2", "text-sm")}>
          Match when{" "}
          {rg.disabled ? (
            {
              or: "any",
              and: "all",
            }[rg.ruleGroup.combinator as "or" | "and"]
          ) : (
            <CiroDropdown
              className={classNames("w-12")}
              isClearable={false}
              value={rg.ruleGroup.combinator}
              options={[
                {
                  label: "all",
                  value: "and",
                },
                {
                  label: "any",
                  value: "or",
                },
              ]}
              onChange={(value) => {
                rg.onCombinatorChange(value);
              }}
            />
          )}{" "}
          conditions apply
        </div>
      </div>
    </div>
  );
};

export default PowersearchRuleGroupHeaderElements;
